import React from 'react'
import Layout from '../Layout'
import DashboardHeader from '../DashboardHeader'
import CartComponent from '../../../utils/CommonFunctionality/Cart'

const Cart = (props) => {
    return (
        <Layout props={props}>
            <DashboardHeader />
            <CartComponent props={props} />
        </Layout>
    )
}

export default Cart
